import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  Box,
  Button,
  useStyleConfig,
} from "@chakra-ui/react";
import {HOST} from "../../lib/Auth";

const TemplatePreview = ({
                          template,
                          selectedTemplate,
                          handleTemplateSelect,
                        }) => {

  const saveButtonStyle = useStyleConfig(
    'SimpleGrid',
    {variant: 'templateSelector', selected: selectedTemplate?.id === template.id}
  );

  return (
    <Box
      key={template.id}
      p={5}
      shadow="md"
      onClick={() => {
        handleTemplateSelect(template)
      }}
      __css={saveButtonStyle}
    >
      <img src={HOST + template.preview} alt="Campaign Template"/>
    </Box>
  )

};

export default TemplatePreview;
